const Routes = Object.freeze({
  // To run sanity tests against localhost,
  // create a .env.development.local with this:
  // REACT_APP_ROOT=/ap-search/
  ROOT: process.env.REACT_APP_ROOT || "/",
  LOGIN: "login",
  LOGOUT: "logout",
  PATIENTS: "patients/",
  SEARCH_PROGRAMS: "search-programs",
  CALLBACK: "/callback"
});

export { Routes };
